<template>
    <div class="addresses">
        <div ref="draggableContainer">
            <template v-for="(address, index) in sharedAddresses" :key="address.id">
                <AddressesBoxItem
                    :class="{ 'js-draggable': index !== 0 }"
                    :data-id="address.id"
                    :address="address"
                    :ipgeo="ipgeo"
                    :index="index"
                    :isLastItem="index === lastItemIndex"
                    :removable="isAddressesRemovable"
                    :draggable="isDraggable"
                    @address-change="emitAddress"
                    @addressesError="handleError"
                    @addressDeleting="handleAddressDeleting"
                    @gis-api-call="$emit('gis-api-call')"
                />
            </template>
        </div>

        <v-btn
            v-show="isAddingAvailable"
            block
            color="#0eccaa"
            density="default"
            variant="tonal"
            rounded="lg"
            elevation="0"
            :prepend-icon="mdiPlusCircle"
            text="Добавить адрес"
            @click="handleAddressAdding"
            class="pl-1 rounded-lg"
        >
        
    </v-btn>
    </div>
</template>

<script setup>
import { mdiPlusCircle } from '@mdi/js';
</script>

<script>
import axios from 'axios';
import AddressesBoxItem from './AddressesBoxItem.vue';
import Sortable from 'sortablejs';

export default {
    name: 'AddresseBox',

    emits: ['address-change', 'addresses-error', 'gis-api-call'],

    components: {
        AddressesBoxItem,
    },

    props: {
        sharedAddresses: {
            type: [Array, Object],
            required: true,
        },
        isAddressesRemovable: {
            type: Boolean,
            required: true,
        },
        maxAddresses: {
            type: [Number, String],
            default: 2
        }
    },

    data() {
        return {
            ipgeo: {
                latitude: null,
                longitude: null,
                region: null,
            },
            sortableInstance: null,
        };
    },

    computed: {
        lastItemIndex() {
            return this.sharedAddresses.length - 1;
        },

        isAddingAvailable() {
            return this.sharedAddresses.length < this.maxAddresses && this.sharedAddresses.every((x) => x.selected);
        },

        isDraggable() {
            return this.sharedAddresses.length > 2;
        },
    },

    mounted() {
        // get ip
        const IPGEO_APIKEY =
            process.env.NODE_ENV == 'production'
                ? process.env.VUE_APP_IPGEO_APIKEY
                : process.env.VUE_APP_IPGEO_APIKEY_RESERVE;
        axios
            .get(`https://api.ipgeolocation.io/ipgeo?apiKey=${IPGEO_APIKEY}`)
            .then((response) => {
                this.ipgeo.latitude = response.data.latitude;
                this.ipgeo.longitude = response.data.longitude;
                this.ipgeo.region = response.data.district
            })
            .catch((err) => console.log(err));

        this.$nextTick(() => {
            this.sortableInstance = Sortable.create(this.$refs.draggableContainer, {
                draggable: '.js-draggable',
                handle: '.js-draggable-handle',
                delay: 0,
                delayOnTouchOnly: false,
                touchStartThreshold: 0,
                animation: 150,
                easing: 'cubic-bezier(1, 0, 0, 1)',
                dataIdAttr: 'data-id',

                onChange: this.handleAddressesReordering.bind(this),
            });
        });
    },

    methods: {
        destroySortable() {
            if (this.sortableInstance) {
                this.sortableInstance.destroy();
                this.sortableInstance = null;
            }
        },

        emitAddress(e) {
            let addresses = JSON.parse(JSON.stringify(this.sharedAddresses));
            addresses[e.index] = e.address;
            this.$emit('address-change', addresses);
        },

        handleAddressAdding() {
            const newId = Math.max(...this.sharedAddresses.map((x) => x.id)) + 1;
            let addresses = JSON.parse(JSON.stringify(this.sharedAddresses));
            addresses.push({
                id: newId,
                selected: null,
                floor: null,
                isElevator: false,
                isElevatorCargo: false,
            });
            this.$emit('address-change', addresses);
        },

        handleAddressDeleting(index) {
            let addresses = this.sharedAddresses;
            addresses.splice(index, 1);
            this.$emit('address-change', addresses);
        },

        handleAddressesReordering(data) {
            const oldIndex = data.oldIndex;
            const newIndex = data.newIndex;
            let addresses = JSON.parse(JSON.stringify(this.sharedAddresses));
            addresses.splice(newIndex, 0, addresses.splice(oldIndex, 1)[0]);
            this.$emit('address-change', addresses);
        },

        handleError() {
            this.$emit('addresses-error', 'Обязательное поле');
        },

        onChange() {
            console.log('List updated:', this.items);
        },
    },

    beforeUnmount() {
        this.destroySortable;
    },
};
</script>
